/* Keep catalogue preferences reachable without putting content beneath the bar. */
let footerObserver;

export function initFooter() {
  const footer = document.querySelector('[data-mx-footer]');
  if (!footer) return;
  const menus = [...footer.querySelectorAll('details')];
  const close = (menu, returnFocus = false) => {
    menu.open = false;
    if (returnFocus) menu.querySelector('summary').focus();
  };
  menus.forEach(menu => menu.addEventListener('toggle', () => {
    if (menu.open) menus.forEach(other => { if (other !== menu) close(other); });
  }));
  menus.forEach(menu => menu.addEventListener('click', event => {
    // The consent dialog remembers its opener: keep that target visible when
    // the policy panel closes, so dismissing the dialog restores useful focus.
    if (event.target.closest('[data-consent-action="manage"]')) close(menu, true);
  }));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = menus.find(menu => menu.open && menu.contains(document.activeElement));
    if (menu) { close(menu, true); event.preventDefault(); }
  });
  document.addEventListener('click', event => {
    if (!footer.contains(event.target)) menus.forEach(menu => close(menu));
  });
  footer.addEventListener('focusout', event => {
    if (event.relatedTarget && !footer.contains(event.relatedTarget)) menus.forEach(menu => close(menu));
  });
  // A normal document footer remains in flow without JS, on detail and map pages.
  if (document.querySelector('.mx-split') || !document.querySelector('[data-mx-grid]') || !document.querySelector('[data-mx-more]') || !('ResizeObserver' in window)) return;
  const root = document.documentElement;
  footer.classList.add('mx-footer--persistent');
  const measure = () => root.style.setProperty('--mx-footer-h', `${Math.ceil(footer.getBoundingClientRect().height)}px`);
  measure();
  root.classList.add('mx-persistent-footer');
  footerObserver = new ResizeObserver(measure);
  footerObserver.observe(footer);
}
